module.exports = __webpack_public_path__ + "static/media/logo.dfd4d8da.svg";